<template>
  <div id="app" :style="backgroundStyle">
    <router-view />
  </div>
</template>

<script>
import backgroundImage from '@/assets/fondo.png';

export default {
  data() {
    return {
      backgroundImage,
    };
  },
  computed: {
    backgroundStyle() {
      return {
        background: `url(${this.backgroundImage}) no-repeat center center fixed`,
        backgroundSize: 'cover',
        height: '100vh',
        width: '100%',
        // overflow: 'hidden',
      };
    },
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: 'FormaDJRDisplay';
  src: url('@/assets/FormaDJRDisplay-Regular.otf') format('opentype');
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-family: 'FormaDJRDisplay', sans-serif!important;
}
</style>
